import { render, staticRenderFns } from "./InspectSection.vue?vue&type=template&id=038b9141&scoped=true"
import script from "./InspectSection.vue?vue&type=script&lang=ts"
export * from "./InspectSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038b9141",
  null
  
)

export default component.exports